import React, {FC, useState, useEffect, useCallback} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {GoPlus} from 'react-icons/go';
import { Link, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
// custom
import NavbarAdmin from '../../../components/navbar/Navbar.admin';
import { IPromotion, PROMOTION_ACTION_TYPE } from '../../../common/state/promotions/promotion';
import { IUserState } from '../../../common/state/profile/user';
import { deletePromotionByIdAdmin, getAllPromotionsAdmin } from '../../../common/async/AsyncCalls';
import PaymentTableAdmin from '../../../components/tables/Payment.table';
import PromotionTableAdmin from '../../../components/tables/Promotion.table';
// custom

const PromotionAdminView : FC = () => {
    const history = useHistory();
    // states
    const [promoList, setPromoList] = useState<IPromotion[] | undefined>(undefined);
    const token: string = useSelector(({user} : {
        user: IUserState
    }) => user.token);
    // actions
    const promoDispatch : (data : {type: PROMOTION_ACTION_TYPE, payload: any}) => void = useDispatch();

    // evt handlers
    function handlePromotionUpdate (promo: IPromotion) {        
        promoDispatch({type: PROMOTION_ACTION_TYPE.SELECT_PROMOTION, payload: promo});
        history.push({pathname: '/admin/promotions/update'});
    }    

    // lifecycle
    const handlePromotionDelete = useCallback(async(item: IPromotion)=>{                             
        try {
            await deletePromotionByIdAdmin(token, item.id);
            toast("Promotion record deleted successfully!");
            promoDispatch({type: PROMOTION_ACTION_TYPE.RESET_PROMOTION, payload: undefined});
            history.push({pathname: '/admin'});
        } catch (err) {
            console.log('Error deleting promotion: ', (err as Error).message);
        }
    },[token]);

    //lifecycle
    const fetchAllPromotion = useCallback(async()=> {
        try {
            // console.log('Token is: ', token);
            const response = await getAllPromotionsAdmin(token);
            // console.log('details are: ', response.data);
            setPromoList(response.data as IPromotion[]);
        } catch(err) {
            console.log('Error fetching admin payments');
        }
            
    }, [token]);

    useEffect(()=>{        
        fetchAllPromotion();
    },[token]);

    return <React.Fragment>
        <NavbarAdmin/>
        <div
            className="h-screen overflow-y-scroll w-screen bg-gray-200 dark:bg-gray-800 flex flex-col justify-start p-4 
                        lg:py-4 lg:px-16 items-between shadow">
            <h2 className="text-gray-700 dark:text-teal-400 text-2xl font-medium mb-2">Manage Payments</h2>
            <p className="text-gray-700 dark:text-gray-300 dartext-base mb-4">
                Create, Update, Delete promotion records*
            </p>
            <section className="w-full flex flex-row justify-end">
                <Link to="/admin/promotions/create" className="bg-primary-500 text-white flex 
                        active:bg-primary-600 font-bold uppercase text-sm px-6 py-3 rounded shadow 
                        hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear 
                        transition-all duration-150" type="button">
                     <GoPlus className="relative mt-1 mr-2 font-bold"/> Promotion
                </Link>
            </section>
            <PromotionTableAdmin 
                list={promoList} 
                onEdit={handlePromotionUpdate} 
                onDelete={handlePromotionDelete}/>
        </div>
    </React.Fragment>;
};

export default PromotionAdminView;